import Request from "@/libs/fetch";

export const sponsorshipList = async (data?: any) =>
  await Request("/sponsorship/search", { data });
